(ns app.front.dashboard.contractor-registration
  (:require [app.front.dashboard.common :as dashboard-common]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.front.session :as session]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::queue-fetch-registration-count
  (fn [{:keys [db]} _]
    (if (:session/user db)
      {:dispatch [::fetch-registration-count]}
      {:async-flow {:rules [{:when     :seen-any-of?
                             :events   [::session/restored-session]
                             :dispatch [::fetch-registration-count]
                             :halt?    true}]}})))

(rf/reg-event-fx ::fetch-registration-count
  (fn [_ _]
    {:comm/command {:command    :contractor-registration/registration-count
                    :method     :get
                    :on-success [::fetch-registration-count.success]}}))

(rf/reg-event-db ::fetch-registration-count.success
  (fn [db [_ _ {:keys [count]}]]
    (assoc db ::registration-count count)))

(rf/reg-sub ::registration-count
  :-> ::registration-count)

(rf/reg-sub ::show-dashlet?
  :<- [::registration-count]
  :-> (every-pred some? pos?))

(defn dashboard-section [tr]
  (let [registration-count (<sub [::registration-count])]
    [:section.dashlet
     [:h2 (tr [:contractor-registration/contractor-registrations])]
     [dashboard-common/link-box-container {:class "justify-between"}
      [dashboard-common/link-box-with-number {:title      (tr [:contractor-registration/open-search])
                                              :href       (href/href :view/contractor-registration-search)
                                              :loading?   (nil? registration-count)
                                              :aria-label (tr [:contractor-registration/open-search])}
       registration-count]]]))
